<div class="alerts-container">
  <greco-alert *ngFor="let alert of alerts$ | async" [config]="alert"></greco-alert>
</div>
